import * as Sentry from "@sentry/react";

Sentry.init({
    dsn: "https://3032666b44384d15a21faabd7ec1e5d0@o305056.ingest.us.sentry.io/4507462312329216",
    environment: "production",
    tracesSampleRate: 0.35,
    release: "1.1.9",
});
